import useAuth from "../Hooks/useAuth";
import { isTokenValid, getTokenString } from "../Utils/helper";

export default function useFetch({ navigate }) {
  const { logout } = useAuth();

  /*const getToken = () => {
const tokenStr = localStorage.getItem('token');
const userToken = JSON.parse(tokenStr);

if (userToken) {
const expire = new Date(userToken.tokenExpiration);
const currentDate = new Date();

if (currentDate < expire) {
return userToken.token;
}

logout();
navigate('/')
}

logout();
navigate('/')
}*/

  //swr will be taking care of get.
  function get(url) {
    const requestOptions = {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        ...authHeader(),
      },
    };

    return fetch(url, requestOptions)
      .then(handleResponse)
      .catch((errors) => {
        return { success: false, errors, logout: false, data: null };
      });
  }

  function form(url, body) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        ...authHeader(),
      },
      credentials: "include",
      body: body,
    };

    return fetch(url, requestOptions)
      .then(handleResponse)
      .catch((errors) => {
        return { success: false, errors, logout: false, data: null };
      });
  }

  function post(url, body) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        ...authHeader(),
      },
      credentials: "include",
      body: JSON.stringify(body),
    };

    return fetch(url, requestOptions)
      .then(handleResponse)
      .catch((errors) => {
        return { success: false, errors, logout: false, data: null };
      });
  }

  function postFile(url, file) {
    const requestOptions = {
      method: "POST",
      headers: {
        ...authHeader(),
      },
      credentials: "include",
      body: file,
    };

    return fetch(url, requestOptions)
      .then(handleResponse)
      .catch((errors) => {
        return { success: false, errors, logout: false, data: null };
      });
  }

  function put(url, body) {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: JSON.stringify(body),
    };

    return fetch(url, requestOptions)
      .then(handleResponse)
      .catch((errors) => {
        return { success: false, errors, logout: false, data: null };
      });
  }

  // For FormData/file bodies: no Content-Type (browser sets the multipart boundary) and no JSON.stringify
  function putFile(url, file) {
    const requestOptions = {
      method: "PUT",
      headers: {
        ...authHeader(),
      },
      credentials: "include",
      body: file,
    };

    return fetch(url, requestOptions)
      .then(handleResponse)
      .catch((errors) => {
        return { success: false, errors, logout: false, data: null };
      });
  }

  // prefixed with underscored because delete is a reserved word in javascript
  function _delete(url) {
    const requestOptions = {
      method: "DELETE",
      headers: authHeader(),
    };

    return fetch(url, requestOptions)
      .then(handleResponse)
      .catch((errors) => {
        return { success: false, errors, logout: false, data: null };
      });
  }

  // helper functions

  function authHeader(auth) {
    // return auth header with jwt if user is logged in and request is to the api url
    if (isTokenValid()) {
      return { Authorization: getTokenString() };
    } else {
      logout();
    }
  }

  function handleResponse(response) {
    return response.text().then((text) => {
      const data = text ? JSON.parse(text) : null;
      if (!response.ok) {
        if (
          response.status === 401 ||
          response.status === 403 ||
          !isTokenValid()
        ) {
          logout();
          navigate("/");
        }
        const errors = (data && data.errors) || response.statusText;
        return { success: false, errors, logout: false, data: null };
      }
      return { success: true, errors: null, logout: false, data };
    });
  }

  return {
    get,
    post,
    form,
    postFile,
    put,
    putFile,
    delete: _delete,
  };
}
